import Card from "./Card";
// import Button from "@components/Button";
import _ from "lodash";
import styles from "./ContentTab.module.scss";
import cx from "classnames";
import { useRouteContext } from "@providers/RouteProvider";
import getter from "@services/RoomService/getter";
import { useBookingContext } from "@providers/BookingProvider";
import { usePageContext } from "@providers/PageProvider";

const View = ({ data }: any) => {
  const { router } = useRouteContext();
  const { booking } = useBookingContext();
  const { hotel } = usePageContext();
  const handler = {
    to: (room: any) => {
      const item = _.find(data, { id: getter.id(room) });
      router.push("room-detail", { slug: getter.slug(item) });
    },
    book: (_room: any) => {
      booking.open({ hotel });
    },
  };

  return (
    <>
      <div className={cx("", styles.content)}>
        {_.map(data, (item, index: number) => (
          <Card
            key={`card_${index}`}
            {...item}
            onBooking={handler.book}
            onDetail={handler.to}
          />
        ))}
      </div>
    </>
  );
};
export default View;
